import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/sections/PageHeader';
import { Card, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { ArrowLeft, ArrowRight, Calendar, Clock, Tag } from 'lucide-react';
import { blogArticles } from './BlogArticlePage';
import '../styles/home.css';

export default function BlogPage() {
  return (
    <div className="home-container">
      <Helmet>
        <title>Blog Naturopathie et Réflexologie - Laura Body Angoulême</title>
        <meta name="description" content="Blog de Laura Body, naturopathe et réflexologue à Angoulême. Articles sur la naturopathie, la réflexologie plantaire, le massage bien-être, les troubles cutanés, le sommeil et le stress." />
        <link rel="canonical" href="https://www.naturopathe-angouleme.fr/blog" />
      </Helmet>

      <PageHeader />

      <section className="page-hero-mini">
        <div className="section-container">
          <Link to="/" className="back-link"><ArrowLeft size={16} /> Retour à l'accueil</Link>
          <h1 className="page-hero-title">Blog – Laura Body Naturopathe Angoulême</h1>
          <p className="page-hero-description">
            Retrouvez les articles de Laura Body sur la naturopathie, la réflexologie plantaire et le bien-être naturel à Angoulême.
          </p>
        </div>
      </section>

      <section className="services-section">
        <div className="section-container">
          <div className="blog-grid" data-testid="blog-articles-grid">
            {blogArticles.map((article) => (
              <Link 
                key={article.id} 
                to={`/blog/${article.id}`} 
                className="blog-card-link"
                data-testid={`blog-card-${article.id}`}
              >
                <Card className="blog-card blog-card-hover">
                  <CardHeader>
                    <div className="blog-card-meta">
                      <span className="blog-card-date">
                        <Calendar size={12} /> {article.date}
                      </span>
                      <span className="blog-card-readtime">
                        <Clock size={12} /> {article.readTime}
                      </span>
                    </div>
                    <div className="blog-tags">
                      {article.tags.slice(0, 3).map((tag) => (
                        <span key={tag} className="blog-tag">
                          <Tag size={10} /> {tag}
                        </span>
                      ))}
                    </div>
                    <CardTitle className="blog-card-title">{article.title}</CardTitle>
                    <CardDescription className="blog-card-description">{article.description}</CardDescription>
                    <div className="blog-card-cta">
                      <span className="blog-read-more">
                        Lire l'article <ArrowRight size={14} />
                      </span>
                    </div>
                  </CardHeader>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
